import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Form,
  notification,
  Radio,
  Row,
  Col,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import {
  CONFIGURATION_CONVERTER,
  CONFIGURATION_USER,
} from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";

const UserPopupContent = ({
  onClose,
  isAdd,

  form,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const location = useLocation();

  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);

  const handleAddFormChange = (changedValues, allValues) => {
    setAddFormData(allValues);
  };

  const handleAddFormSubmit = async () => {
    try {
      const formData = {};

      handleNotification("Successfully Saved");
      handleClear();
      onClose();
    } catch (err) {
      console.error(err);
    }
  };

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <Form
      form={form}
      onFinish={handleAddFormSubmit}
      name="add-group-form"
      className="font-bold w-[600px]"
      // labelCol={{ span: 8 }}
      layout="vertical"
      onValuesChange={handleAddFormChange}
      initialValues={{}}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Name"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter name" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="UserName"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter username" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Password"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter password" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Confirm Password"
            name="GroupName1"
            rules={[{ required: true, message: "Please confirm  password" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Email id"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter email" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Mobile"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter mobile number" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Company Name"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter company name" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Designation"
            name="GroupName1"
            rules={[{ required: true, message: "Please enter designation" }]}
          >
            <Input className="group-input" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Admin"
            name="admin"
            rules={[{ required: true, message: "Please select yes or no" }]}
            className="flex center"
          >
            <Radio.Group>
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item className="flex justify-end">
        <Button htmlType="submit" className="blue-btn mr-2">
          Save
        </Button>
        <Button className="blue-btn" onClick={handleClear}>
          Clear
        </Button>
      </Form.Item>
    </Form>
  );
};

const UserPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  fetchFlowGroupList,
  updateRecord,
  flowGroupList,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();

  // console.log(updateRecord);
  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_USER}/user-add-popup`) {
      setIsAdd(true);

      form.resetFields();
    } else {
      setIsAdd(false);
    }
  }, [location.pathname, form]);

  const handleClose = () => {
    setIsAdd(false);

    navigate(`${CONFIGURATION_USER}`);
    form.resetFields();
  };

  return (
    <>
      <PopupUI
        popupContent={
          <UserPopupContent
            onClose={handleClose}
            isAdd={isAdd}
            isUpdate={isUpdate}
            form={form}
            hasModal={true}
            title={title}
          />
        }
        key={updateRecord?.groupID}
        isAdd={isAdd}
        setIsUpdate={setIsUpdate}
        handleClose={handleClose}
        isOpen={isUpdate || isAdd}
        hasModal={true}
        title={title}
      />
    </>
  );
};

export default UserPopup;
